<template>
  <div
    ref="commentList"
    class="comment-list"
    v-infinite-scroll="() => getList(page + 1)"
    :infinite-scroll-immediate="false"
    :infinite-scroll-disabled="loading || noMoreData || noData"
    :infinite-scroll-distance="1"
  >
    <div v-for="item in commentList" :key="item.id" class="item">
      <div class="item-header">
        <el-image class="avatar" fit="contain" :src="item.avatar"></el-image>
        <div class="name v-ellipsis">{{ item.nickname }}</div>
        <div class="time">{{ item.createTime }}</div>
        <div v-if="user.lid == item.lid" class="operate">
          <span v-if="item.status == 1" class="status">待审核</span>
          <span v-if="item.status == 3" class="status v-color-red">拒绝</span>
          <i
            v-if="item.status == 1"
            class="iconfont icon-edit"
            :class="{ disabled: item.status != 1 }"
            @click="editRow(item)"
          ></i>
          <i
            v-if="isMobile"
            class="iconfont icon-trash"
            @click="deleteComment(item)"
          ></i>
          <el-popconfirm
            v-if="!isMobile"
            title="确认删除？"
            @onConfirm="doDelete(item)"
          >
            <i slot="reference" class="iconfont icon-trash"></i>
          </el-popconfirm>
        </div>
      </div>
      <div class="item-content">{{ item.content }}</div>
    </div>
    <div v-if="noMoreData" class="no-more-data">没有更多数据了...</div>
    <div v-if="noData" class="no-data">暂无评论数据...</div>
    <div v-loading="loading" element-loading-text="评论数据加载中.."></div>
    <fix-side-comment-edit
      v-if="isShowEdit"
      :show.sync="isShowEdit"
      :row="row"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import fixSideCommentEdit from "./fix-side-comment-edit.vue";
import { Dialog, Toast } from "vant";
export default {
  components: { fixSideCommentEdit },
  data() {
    return {
      worksId: this.$route.query.id,
      lists: [],
      loading: false,
      row: null,
      user: JSON.parse(localStorage.getItem("v-comment-user")),
      isShowEdit: false,
    };
  },

  created() {
    this.getList();
  },

  computed: {
    ...mapState("preview", [
      "commentList",
      "commentListData",
      "commentListPage",
    ]),
    page() {
      return this.commentListPage;
    },
    noData() {
      return (
        this.page === 1 &&
        this.commentListData.data &&
        this.commentListData.data.length === 0
      );
    },
    noMoreData() {
      return (
        this.page > 1 &&
        this.commentListData.data &&
        this.commentListData.data.length === 0
      );
    },
  },

  watch: {
    page(value) {
      if (value === 1) {
        this.$refs.commentList.scrollTop = 0;
      }
    },
  },

  methods: {
    ...mapActions("preview", {
      actionGetCommentList: "getCommentList",
    }),
    //列表
    async getList(page) {
      this.loading = true;
      await this.actionGetCommentList({ worksId: this.worksId, page });
      this.loading = false;
    },

    async deleteComment(row) {
      try {
        await Dialog.confirm({ title: "确认删除?" });
        this.doDelete(row);
      } catch (e) {
        console.warn("用户取消删除");
      }
    },

    editRow(row) {
      this.row = row;
      if (row.status == 1) {
        this.isShowEdit = true;
      }
    },

    async doDelete(row) {
      this.$set(row, "deleteLoading", true);
      try {
        await this.api.comment.delete({ id: row.id });
        this.isMobile
          ? Toast({ message: "删除成功", position: "bottom" })
          : this.$message.success("删除成功");
        this.getList(1);
      } catch (e) {
        console.error(e);
      }
      this.$set(row, "deleteLoading", false);
    },
  },
};
</script>

<style scoped>
.comment-list {
  height: 300px;
  overflow-y: auto;
  margin-bottom: 20px;
}

.comment-list .item {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ddd;
}

.comment-list .item-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.comment-list .avatar {
  width: 24px;
  height: 24px;
  border-radius: 100%;
  background: #ddd;
  border: 1px solid #ddd;
}
.comment-list .name {
  font-size: 13px;
  margin: 0 10px;
  max-width: 100px;
}
.comment-list .item-content {
  line-height: 1.5;
  letter-spacing: 1px;
  font-size: 13px;
  color: #666;
}
.comment-list .time {
  font-size: 12px;
  color: #999;
}
.comment-list .operate {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.comment-list .operate .iconfont {
  font-size: 12px;
  cursor: pointer;
  color: #999;
  margin-left: 5px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.comment-list .operate .iconfont.disabled{
  opacity: 0.5;
}
.no-more-data {
  display: flex;
  height: 30px;
  font-size: 12px;
  color: #999;
  justify-content: center;
  align-items: center;
}

.no-data {
  display: flex;
  height: 100%;
  font-size: 12px;
  color: #999;
  justify-content: center;
  align-items: center;
}
.operate .status {
  font-size: 12px;
  color: #e6a23c;
  margin-right: 5px;
}
</style>
